
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34513',
  depVersions: {
  "documents-public-ui": "static-1.34513",
  "atom": "static-1.5076",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2501",
  "client-types": "static-1.466",
  "cssUtils": "static-1.794",
  "customer-data-filters-ui": "static-1.39779",
  "customer-data-objects": "static-1.7674",
  "customer-data-property-utils": "static-1.8094",
  "documents-lib": "static-1.34518",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.338",
  "FormsCommonComponents": "static-1.85849",
  "FormUrlGenerator": "static-2.4723",
  "foundations-theming-specialty": "static-1.2138",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5597",
  "hs-test-utils": "static-1.8017",
  "hub-http": "static-1.6226",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11783",
  "HubStyleTokens": "static-2.11476",
  "I18n": "static-7.1628",
  "icons": "static-2.647",
  "jasmine-immutable": "static-1.3025",
  "jasmine-runner": "static-1.6469",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7161",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5406",
  "quartz": "static-1.7039",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.9",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5347",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8176",
  "reference-resolvers-lite": "static-1.8099",
  "reporting-data": "static-1.67555",
  "reporting-reports": "static-1.67233",
  "reporting-snowflake": "static-1.56173",
  "reporting-testing-lib": "static-1.9488",
  "reporting-visualizations": "static-1.59631",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8948",
  "sanitize": "static-1.4482",
  "sanitize-text": "static-1.8146",
  "self-service-api": "static-1.10252",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1753",
  "signup-constants": "static-1.18841",
  "signup-ui-url-generator": "static-2.8052",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4765",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4767",
  "ui-addon-form-validation": "static-1.10995",
  "ui-asset-management-lib": "static-1.11037",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8422",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "static-1.7066",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9674",
  "foundations-components": "static-1.7940",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.817",
  "quartz-core": "static-1.6258",
  "quick-fetch": "static-1.3919",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4657",
  "ui-addon-i18n": "static-1.11154",
  "ui-addon-upgrades": "static-9.17998",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3402",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3316",
  "quartz-webpack": "static-1.3263",
  "foundations-assets": "static-1.4870",
  "foundations-theming": "static-1.4422",
  "hub-http-shared-msw-handlers": "static-1.9964",
  "hubspotter-http": "static-1.4654",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.226",
  "conversations-skeleton-state": "static-1.7252",
  "crm-message-bus": "static-1.42988",
  "customer-data-filters-ui-msw-helpers": "static-1.22214",
  "customer-data-objects-ui-components": "static-1.13031",
  "customer-data-reference-ui-components": "static-1.13167",
  "customer-data-ui-utilities": "static-1.9830",
  "framework-builder-read-service-client": "static-1.4007",
  "framework-data-schema-quick-fetch": "static-1.6793",
  "framework-data-schema-resolvers": "static-1.6888",
  "inbound-db-meta-service-client": "static-1.3588",
  "inbound-db-properties-service-client": "static-1.3848",
  "multi-account-reference-resolvers": "static-1.985",
  "onboarding-tours": "static-1.16608",
  "reporting-datasets-permissions-lib": "static-1.13683",
  "ui-addon-teams": "static-1.21559",
  "quartz-auth": "static-1.714",
  "ui-business-units-lib": "static-1.9058",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "static-1.8986",
  "ContentUtils": "static-1.68366",
  "customer-data-properties": "static-1.51561",
  "forms-ai-lib": "static-1.4323",
  "forms-utils-lib": "static-1.12589",
  "foundations-components-test-utils": "static-1.5423",
  "react-dnd-compat": "static-1.4619",
  "react-tinymce": "static-1.55244",
  "tinymce-config": "static-2.54370",
  "ui-gdpr-components": "static-1.10354",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3407",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3128",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.83",
  "ui-fonts": "static-1.738",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4332",
  "csstype": "static-1.50",
  "quartz-head": "static-1.704",
  "web-vitals": "static-1.5",
  "batch-promise": "static-1.1544",
  "external-options-client-types": "static-1.4160",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.714",
  "frontend-preferences-client": "static-1.7933",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3701",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25380",
  "hubspot-apollo-client": "static-1.4883",
  "foundations-components-legacy": "static-1.965",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.469",
  "hs-story-utils": "static-1.9429",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.232",
  "timezone-utils": "static-2.5249",
  "bend-plugin-foundations-components": "static-1.4209",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1956",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.714",
  "quartz-tracking": "static-1.418",
  "bend-plugin-chirp-manifest": "static-1.67",
  "chirp-fetch": "static-1.1892",
  "purchase-motions-components": "static-1.5910",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4082",
  "bender-build-tools": "static-1.3205",
  "amplitude-session-replay-browser": "static-1.60",
  "bend-plugin-foundations-theming": "static-1.2905",
  "stylex": "static-1.33",
  "hs-resources": "static-1.154",
  "pulse": "static-1.578",
  "restore-request-side-panel-lib": "static-1.897",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3799",
  "crm-pipelines-api-client-types": "static-1.4140",
  "fdsr-migration-layer": "static-1.7",
  "multi-currency-client-types": "static-1.3693",
  "getting-started-shared-tasks": "static-1.18472",
  "growth-data-modal": "static-1.5432",
  "growth-onboarding-confetti": "static-1.3070",
  "growth-onboarding-next-action-utils": "static-1.1919",
  "navigation-components": "static-1.18043",
  "onboarding-tours-client": "static-1.4822",
  "onboarding-tours-utils": "static-1.674",
  "ui-shepherd-react": "static-3.10168",
  "ui-shepherd-tracker": "static-1.7549",
  "ui-universal-auth": "static-1.8984",
  "user-context": "static-1.5108",
  "hubspotter-http-shared-msw-handlers": "static-1.9962",
  "chatspot-core": "static-1.21323",
  "copilot-toolkit": "static-1.11139",
  "cms-field-types": "static-1.4815",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16135",
  "calling-global-api": "static-1.64514",
  "calling-internal-common": "static-1.31308",
  "calling-lifecycle-internal": "static-1.65896",
  "calling-lifecycle-messages": "static-1.58190",
  "commerce-products-lib": "static-1.9561",
  "crm-links": "static-1.6298",
  "customer-data-properties-shared-msw-handlers": "static-1.9291",
  "file-manager-components": "static-1.23633",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4225",
  "meetings-icalendar-utils-lib": "static-1.636",
  "object-builder-ui-client": "static-1.48750",
  "pipeline-validation-client-types": "static-1.3967",
  "property-value-citations": "static-1.2175",
  "smart-property-lib": "static-1.7036",
  "tiered-pricing": "static-1.1224",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9062",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19840",
  "tinymce-themes": "static-1.56340",
  "data-token-picker": "static-1.16414",
  "hub-http-contrib": "static-1.3047",
  "interframe": "static-3.4765",
  "tinymce-data": "static-1.40455",
  "tinymce-plugins": "static-1.57484",
  "ui-addon-sales-email": "static-1.5216",
  "onboarding-scopes": "static-1.6466",
  "ui-addon-opt": "static-4.8373",
  "apollo-link-hub-http": "static-2.4655",
  "hubspot-apollo-cache": "static-1.342",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.178",
  "purchase-motions-api": "static-1.5913",
  "trials-service-types": "static-1.3907",
  "bend-plugin-pulse": "static-1.81",
  "directed-graph": "static-1.939",
  "event-emitter": "static-1.952",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1961",
  "growth-onboarding-next-action-components": "static-1.1947",
  "user-context-client": "static-1.4618",
  "idb-keyval": "static-1.44",
  "magpie-lib": "static-1.5555",
  "magpie-types": "static-1.5015",
  "nest": "static-1.231",
  "reactive-lib": "static-1.727",
  "simple-logging-lib": "static-1.3053",
  "unified-auth-core-lib": "static-1.780",
  "getting-started-shared-tasks-store": "static-1.17590",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13550",
  "integrations-tracking-lib": "static-1.5605",
  "native-integrations-shared-strings": "static-1.7787",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10370",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.498",
  "calling-error-reporting": "static-1.31315",
  "shared-worker-versioning": "static-1.11040",
  "calling-usage-tracker": "static-1.6545",
  "voice-sms-access-library": "static-1.978",
  "customer-data-tracking": "static-1.6892",
  "commerce-permissions": "static-1.773",
  "products-iframe-lib": "static-1.7934",
  "products-ui-components-shared-msw-handlers": "static-1.10346",
  "location-customization-utils-lib": "static-1.9260",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4158",
  "video-components-external": "static-1.11269",
  "video-data-lib": "static-1.34927",
  "data-agent-kit": "static-1.196",
  "feedback-loader": "static-1.29300",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10047",
  "fsm": "static-1.3735",
  "policy-lib": "static-1.6783",
  "react-colorpicker": "static-2.10212",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10110",
  "navigation-messaging": "static-1.7370",
  "FileManagerLib": "static-1.39273",
  "NamespacedHubStyle": "static-2.9061",
  "FileManagerCore": "static-1.39132",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7757",
  "layout-dnd-components": "static-1.12454",
  "layout-dnd-utils": "static-1.11429",
  "react-codemirror": "static-1.10631",
  "ui-addon-emoji-picker": "static-1.9892",
  "ui-brand-identity-lib": "static-1.15281",
  "InboxConnectUtils": "static-4.14813",
  "meetings-connect-utils-lib": "static-1.7609",
  "universal-page-editor-lib": "static-1.3017",
  "google-sheets-integration-lib": "static-1.237",
  "microsoft-drive-integration-lib": "static-1.356",
  "slack-ui-library": "static-1.10398",
  "calling-orchestration-schema": "static-1.35755",
  "sales-views-client-types": "static-1.4264",
  "crm-record-cards-service-types": "static-1.3599",
  "content-media-composition-data-lib": "static-1.12284",
  "content-media-compositions": "static-2.16291",
  "media-bridge-lib": "static-1.18932",
  "trellis-story-utils": "static-1.4520",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5918",
  "FileManagerImages": "static-1.36784",
  "video-components": "static-1.13272",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4542",
  "video-embed": "static-1.35761",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8707",
  "ui-coaching-tips": "static-1.28557",
  "ContentData": "static-1.68441",
  "layout-data-lib": "static-1.9754",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22111",
  "outpost": "static-1.4186",
  "growth-onboarding-feedback-components": "static-1.6585",
  "advanced-menus-core": "static-1.15132",
  "advanced-menus-lib": "static-1.12072",
  "ExportDialog": "static-6.10393",
  "ui-memberships-settings-lib": "static-1.34046",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15131",
  "simple-menus-lib": "static-1.16648"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34513",
  "atom": "/atom/static-1.5076",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2501",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39779",
  "customer-data-objects": "/customer-data-objects/static-1.7674",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8094",
  "documents-lib": "/documents-lib/static-1.34518",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.338",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85849",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4723",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2138",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5597",
  "hs-test-utils": "/hs-test-utils/static-1.8017",
  "hub-http": "/hub-http/static-1.6226",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11783",
  "HubStyleTokens": "/HubStyleTokens/static-2.11476",
  "I18n": "/I18n/static-7.1628",
  "icons": "/icons/static-2.647",
  "jasmine-immutable": "/jasmine-immutable/static-1.3025",
  "jasmine-runner": "/jasmine-runner/static-1.6469",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7161",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5406",
  "quartz": "/quartz/static-1.7039",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.9",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5347",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8176",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8099",
  "reporting-data": "/reporting-data/static-1.67555",
  "reporting-reports": "/reporting-reports/static-1.67233",
  "reporting-snowflake": "/reporting-snowflake/static-1.56173",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9488",
  "reporting-visualizations": "/reporting-visualizations/static-1.59631",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8948",
  "sanitize": "/sanitize/static-1.4482",
  "sanitize-text": "/sanitize-text/static-1.8146",
  "self-service-api": "/self-service-api/static-1.10252",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1753",
  "signup-constants": "/signup-constants/static-1.18841",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8052",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4765",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4767",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10995",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11037",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8422",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "/viral-links-lib/static-1.7066",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9674",
  "foundations-components": "/foundations-components/static-1.7940",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.817",
  "quartz-core": "/quartz-core/static-1.6258",
  "quick-fetch": "/quick-fetch/static-1.3919",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4657",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11154",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17998",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3402",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3316",
  "quartz-webpack": "/quartz-webpack/static-1.3263",
  "foundations-assets": "/foundations-assets/static-1.4870",
  "foundations-theming": "/foundations-theming/static-1.4422",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9964",
  "hubspotter-http": "/hubspotter-http/static-1.4654",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.226",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7252",
  "crm-message-bus": "/crm-message-bus/static-1.42988",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22214",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13031",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13167",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9830",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4007",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6793",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6888",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3588",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3848",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.985",
  "onboarding-tours": "/onboarding-tours/static-1.16608",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13683",
  "ui-addon-teams": "/ui-addon-teams/static-1.21559",
  "quartz-auth": "/quartz-auth/static-1.714",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9058",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8986",
  "ContentUtils": "/ContentUtils/static-1.68366",
  "customer-data-properties": "/customer-data-properties/static-1.51561",
  "forms-ai-lib": "/forms-ai-lib/static-1.4323",
  "forms-utils-lib": "/forms-utils-lib/static-1.12589",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5423",
  "react-dnd-compat": "/react-dnd-compat/static-1.4619",
  "react-tinymce": "/react-tinymce/static-1.55244",
  "tinymce-config": "/tinymce-config/static-2.54370",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10354",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3407",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3128",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.83",
  "ui-fonts": "/ui-fonts/static-1.738",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4332",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.704",
  "web-vitals": "/web-vitals/static-1.5",
  "batch-promise": "/batch-promise/static-1.1544",
  "external-options-client-types": "/external-options-client-types/static-1.4160",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.714",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7933",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3701",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4883",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.965",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.469",
  "hs-story-utils": "/hs-story-utils/static-1.9429",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.232",
  "timezone-utils": "/timezone-utils/static-2.5249",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4209",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1956",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.714",
  "quartz-tracking": "/quartz-tracking/static-1.418",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.67",
  "chirp-fetch": "/chirp-fetch/static-1.1892",
  "purchase-motions-components": "/purchase-motions-components/static-1.5910",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4082",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2905",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.154",
  "pulse": "/pulse/static-1.578",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.897",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3799",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4140",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.7",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3693",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18472",
  "growth-data-modal": "/growth-data-modal/static-1.5432",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3070",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1919",
  "navigation-components": "/navigation-components/static-1.18043",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4822",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.674",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10168",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7549",
  "ui-universal-auth": "/ui-universal-auth/static-1.8984",
  "user-context": "/user-context/static-1.5108",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9962",
  "chatspot-core": "/chatspot-core/static-1.21323",
  "copilot-toolkit": "/copilot-toolkit/static-1.11139",
  "cms-field-types": "/cms-field-types/static-1.4815",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16135",
  "calling-global-api": "/calling-global-api/static-1.64514",
  "calling-internal-common": "/calling-internal-common/static-1.31308",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65896",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58190",
  "commerce-products-lib": "/commerce-products-lib/static-1.9561",
  "crm-links": "/crm-links/static-1.6298",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9291",
  "file-manager-components": "/file-manager-components/static-1.23633",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4225",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.636",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48750",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3967",
  "property-value-citations": "/property-value-citations/static-1.2175",
  "smart-property-lib": "/smart-property-lib/static-1.7036",
  "tiered-pricing": "/tiered-pricing/static-1.1224",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9062",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19840",
  "tinymce-themes": "/tinymce-themes/static-1.56340",
  "data-token-picker": "/data-token-picker/static-1.16414",
  "hub-http-contrib": "/hub-http-contrib/static-1.3047",
  "interframe": "/interframe/static-3.4765",
  "tinymce-data": "/tinymce-data/static-1.40455",
  "tinymce-plugins": "/tinymce-plugins/static-1.57484",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5216",
  "onboarding-scopes": "/onboarding-scopes/static-1.6466",
  "ui-addon-opt": "/ui-addon-opt/static-4.8373",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4655",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.342",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.178",
  "purchase-motions-api": "/purchase-motions-api/static-1.5913",
  "trials-service-types": "/trials-service-types/static-1.3907",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.81",
  "directed-graph": "/directed-graph/static-1.939",
  "event-emitter": "/event-emitter/static-1.952",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1961",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1947",
  "user-context-client": "/user-context-client/static-1.4618",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-lib": "/magpie-lib/static-1.5555",
  "magpie-types": "/magpie-types/static-1.5015",
  "nest": "/nest/static-1.231",
  "reactive-lib": "/reactive-lib/static-1.727",
  "simple-logging-lib": "/simple-logging-lib/static-1.3053",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.780",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17590",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13550",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5605",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7787",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10370",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.498",
  "calling-error-reporting": "/calling-error-reporting/static-1.31315",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11040",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6545",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.978",
  "customer-data-tracking": "/customer-data-tracking/static-1.6892",
  "commerce-permissions": "/commerce-permissions/static-1.773",
  "products-iframe-lib": "/products-iframe-lib/static-1.7934",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10346",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9260",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4158",
  "video-components-external": "/video-components-external/static-1.11269",
  "video-data-lib": "/video-data-lib/static-1.34927",
  "data-agent-kit": "/data-agent-kit/static-1.196",
  "feedback-loader": "/feedback-loader/static-1.29300",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10047",
  "fsm": "/fsm/static-1.3735",
  "policy-lib": "/policy-lib/static-1.6783",
  "react-colorpicker": "/react-colorpicker/static-2.10212",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10110",
  "navigation-messaging": "/navigation-messaging/static-1.7370",
  "FileManagerLib": "/FileManagerLib/static-1.39273",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9061",
  "FileManagerCore": "/FileManagerCore/static-1.39132",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7757",
  "layout-dnd-components": "/layout-dnd-components/static-1.12454",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11429",
  "react-codemirror": "/react-codemirror/static-1.10631",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9892",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15281",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14813",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7609",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3017",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.237",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.356",
  "slack-ui-library": "/slack-ui-library/static-1.10398",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35755",
  "sales-views-client-types": "/sales-views-client-types/static-1.4264",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3599",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12284",
  "content-media-compositions": "/content-media-compositions/static-2.16291",
  "media-bridge-lib": "/media-bridge-lib/static-1.18932",
  "trellis-story-utils": "/trellis-story-utils/static-1.4520",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5918",
  "FileManagerImages": "/FileManagerImages/static-1.36784",
  "video-components": "/video-components/static-1.13272",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4542",
  "video-embed": "/video-embed/static-1.35761",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8707",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28557",
  "ContentData": "/ContentData/static-1.68441",
  "layout-data-lib": "/layout-data-lib/static-1.9754",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22111",
  "outpost": "/outpost/static-1.4186",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6585",
  "advanced-menus-core": "/advanced-menus-core/static-1.15132",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12072",
  "ExportDialog": "/ExportDialog/static-6.10393",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34046",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15131",
  "simple-menus-lib": "/simple-menus-lib/static-1.16648"
}
};
